// 统一导出所有路由模块
import layoutRoutes from './layout'
import authRoutes from './auth'
import bidderRoutes from './bidder'
import agentRoutes from './agent'
import evaluationRoutes from './evaluation'
import expertRoutes from './expert'

export default [
  ...layoutRoutes,
  ...authRoutes,
  ...bidderRoutes,
  ...agentRoutes,
  ...evaluationRoutes,
  ...expertRoutes,
]
